import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerPerpsMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_21718_3029",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				stroke: "#1A1B23",
				strokeWidth: .888889
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: .888889
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_21718_3029)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6 3.33333V5.99999",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 3.33333V5.99999",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66666 6H5.33332C4.96513 6 4.66666 6.29848 4.66666 6.66667V9.33333C4.66666 9.70152 4.96513 10 5.33332 10H6.66666C7.03485 10 7.33332 9.70152 7.33332 9.33333V6.66667C7.33332 6.29848 7.03485 6 6.66666 6Z",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66666 6H5.33332C4.96513 6 4.66666 6.29848 4.66666 6.66667V9.33333C4.66666 9.70152 4.96513 10 5.33332 10H6.66666C7.03485 10 7.33332 9.70152 7.33332 9.33333V6.66667C7.33332 6.29848 7.03485 6 6.66666 6Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 10V11.3333",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 10V11.3333",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 2V3.33333",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 2V3.33333",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 3.33333H10.6667C10.2985 3.33333 10 3.63181 10 3.99999V8C10 8.36819 10.2985 8.66666 10.6667 8.66666H12C12.3682 8.66666 12.6667 8.36819 12.6667 8V3.99999C12.6667 3.63181 12.3682 3.33333 12 3.33333Z",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 3.33333H10.6667C10.2985 3.33333 10 3.63181 10 3.99999V8C10 8.36819 10.2985 8.66666 10.6667 8.66666H12C12.3682 8.66666 12.6667 8.36819 12.6667 8V3.99999C12.6667 3.63181 12.3682 3.33333 12 3.33333Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 8.66667V10.6667",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 8.66667V10.6667",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgHypertrackerPerpsMenuMobileIcon;
